import { Styles } from "../../../../config"

const styles = {
	container: {
		width: "100%",
		justifyContent: "center"
	},

	button({ color }) {
		return {
			width: "100%",
			height: "40px",
			textTransform: "none",
			fontSize: Styles.FontSize.t6.size,
			fontWeight: Styles.FontSize.t6.weight,
			color: Styles.Color.white,
			background: Styles.Color?.[color],
			opacity: 0.9,

			":hover": {
				color: Styles.Color.white,
				background: Styles.Color?.[color],
				opacity: 0.75
			}
		}
	}
}

export default styles
